import * as React from "react";

import primaryColour from "../../constants";

function SvgAccident(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.90824 17.8769C2.70801 16.2271 2 14.1963 2 12C2 10.2122 2.46914 8.53402 3.29102 7.08179H4.43473C4.86222 7.08179 5.22395 7.43207 5.22395 7.84604V8.80136H8.31503C8.64387 8.80136 8.93983 8.96058 9.10424 9.21533L11.5377 13.0048L13.9711 13.2595C14.563 13.3232 15.0233 13.769 15.0562 14.3422L15.1549 16.635C15.1878 17.3037 14.6287 17.8769 13.9382 17.8769H13.2476C13.149 19.1825 11.998 20.2333 10.6169 20.2333C9.23578 20.2333 8.08484 19.2143 7.98619 17.8769H3.90824ZM5.25683 12.7182V10.5846H7.82177L9.2029 12.7182H5.25683ZM10.6827 18.8959C9.99211 18.8959 9.4002 18.3545 9.4002 17.654C9.4002 16.9852 9.95922 16.4121 10.6827 16.4121C11.4061 16.4121 11.9651 16.9534 11.9651 17.654C11.9323 18.3545 11.3732 18.8959 10.6827 18.8959Z"
        fill={fill}
      />
      <path
        d="M10.0336 3.43359L9.70227 7.14275C10.1307 7.36789 10.5071 7.70082 10.7846 8.13082L10.7871 8.13468L11.5197 9.27551L11.6395 7.93477L12.9669 9.29145L14.4231 8.07408L14.4023 9.972L16.2928 10.1409L14.9547 11.4501C16.0776 11.8585 16.9752 12.8725 17.0529 14.2277L17.0537 14.242L17.0836 14.9347L20.4718 14.9717L17.6568 11.6044L20.794 8.535L16.4224 8.14449L16.4703 3.75575L13.103 6.5708L10.0336 3.43359Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgAccident;
